import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FilterBuilderComponent } from '../../filter-builder/filter-builder.component';

@Component({
  selector: 'app-filters-dialog',
  templateUrl: './filters-dialog.component.html',
  styleUrls: ['./filters-dialog.component.scss']
})
export class FiltersDialogComponent implements AfterViewInit {

  @ViewChild('filterBuilder') filterBuilder: FilterBuilderComponent;

  constructor(public dialogRef: MatDialogRef<FiltersDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngAfterViewInit(): void {
    this.filterBuilder.setFields(this.data.fields);
    this.filterBuilder.setInitialFilters(this.data.filters);
    this.filterBuilder.setFormValidators(this.data.validators);
  }

  filter(): void {
    if (this.filterBuilder.validate()) {
      this.dialogRef.close(this.filterBuilder.getFilters());
    }
  }

}
